import { CALL_API, Schemas } from '../../common/middleware/api';
import globalize from '../../common/services/globalize';
import moment from 'moment';

export const ENROLMENTS_REQUEST = 'ENROLMENTS_REQUEST';
export const ENROLMENTS_SUCCESS = 'ENROLMENTS_SUCCESS';
export const ENROLMENTS_FAILURE = 'ENROLMENTS_FAILURE';

export const ENROLMENT_FETCH_REQUEST = 'ENROLMENT_GET_REQUEST';
export const ENROLMENT_FETCH_SUCCESS = 'ENROLMENT_GET_SUCCESS';
export const ENROLMENT_FETCH_FAILURE = 'ENROLMENT_GET_FAILURE';

export const ENROLMENTS_BY_CHILD_REQUEST = 'ENROLMENTS_BY_CHILD_REQUEST';
export const ENROLMENTS_BY_CHILD_SUCCESS = 'ENROLMENTS_BY_CHILD_SUCCESS';
export const ENROLMENTS_BY_CHILD_FAILURE = 'ENROLMENTS_BY_CHILD_FAILURE';

export const CANCEL_AND_REFUND_ENROLMENT_REQUEST = 'CANCEL_AND_REFUND_ENROLMENT_REQUEST';
export const CANCEL_AND_REFUND_ENROLMENT_SUCCESS = 'CANCEL_AND_REFUND_ENROLMENT_SUCCESS';
export const CANCEL_AND_REFUND_ENROLMENT_FAILURE = 'CANCEL_AND_REFUND_ENROLMENT_FAILURE';

export const CANCEL_ENROLMENT_REQUEST = 'CANCEL_ENROLMENT_REQUEST';
export const CANCEL_ENROLMENT_SUCCESS = 'CANCEL_ENROLMENT_SUCCESS';
export const CANCEL_ENROLMENT_FAILURE = 'CANCEL_ENROLMENT_FAILURE';

export const DELETE_AUTO_ENROLMENT_REQUEST = 'DELETE_AUTO_ENROLMENT_REQUEST';
export const DELETE_AUTO_ENROLMENT_SUCCESS = 'DELETE_AUTO_ENROLMENT_SUCCESS';
export const DELETE_AUTO_ENROLMENT_FAILURE = 'DELETE_AUTO_ENROLMENT_FAILURE';

export const ENROLMENTS_EXPORT_REQUEST = 'ENROLMENTS_EXPORT_REQUEST';
export const ENROLMENTS_EXPORT_SUCCESS = 'ENROLMENTS_EXPORT_SUCCESS';
export const ENROLMENTS_EXPORT_FAILURE = 'ENROLMENTS_EXPORT_FAILURE';

export const CHILD_BADGES_EXPORT_REQUEST = 'CHILD_BADGES_EXPORT_REQUEST';
export const CHILD_BADGES_EXPORT_SUCCESS = 'CHILD_BADGES_EXPORT_SUCCESS';
export const CHILD_BADGES_EXPORT_FAILURE = 'CHILD_BADGES_EXPORT_FAILURE';

export const loadEnrolments = (options) => ({
	[CALL_API]: {
		types: [ENROLMENTS_REQUEST, ENROLMENTS_SUCCESS, ENROLMENTS_FAILURE],
		endpoint: 'api/enrolments',
		request: options,
		schema: Schemas.ENROLMENTS_ARRAY
	},
	parentId: options && options.parentId
});

export const fetchEnrolment = (id) => ({
	[CALL_API]: {
		types: [ENROLMENT_FETCH_REQUEST, ENROLMENT_FETCH_SUCCESS, ENROLMENT_FETCH_FAILURE],
		endpoint: `api/enrolments/${id}`,
		schema: Schemas.ENROLMENT
	}
});

export const loadEnrolmentsForChild = (childId, onSuccessEvent) => (dispatch, getState) => {
	const enrolmentsByChild = getState().filters.enrolmentsByChild;
	if (enrolmentsByChild[childId]) {
		onSuccessEvent && onSuccessEvent();
		return null;
	}

	dispatch({
		[CALL_API]: {
			types: [ENROLMENTS_BY_CHILD_REQUEST, ENROLMENTS_BY_CHILD_SUCCESS, ENROLMENTS_BY_CHILD_FAILURE],
			endpoint: 'api/enrolments',
			request: { childId, pageSize: 999 },
			schema: Schemas.ENROLMENTS_ARRAY,
			onSuccessEvent
		},
		childId
	});
};


export const cancelAndRefundEnrolment = (enrolmentId, options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [CANCEL_AND_REFUND_ENROLMENT_REQUEST, CANCEL_AND_REFUND_ENROLMENT_SUCCESS, CANCEL_AND_REFUND_ENROLMENT_FAILURE],
		endpoint: `api/enrolments/cancelAndRefund/${enrolmentId}`,
		method: 'PUT',
		request: options,
		schema: Schemas.ENROLMENT,
		form: 'enrolment',
		onSuccessEvent
	}
});

export const cancelEnrolment = (enrolmentId, onSuccessEvent) => ({
	[CALL_API]: {
		types: [CANCEL_ENROLMENT_REQUEST, CANCEL_ENROLMENT_SUCCESS, CANCEL_ENROLMENT_FAILURE],
		endpoint: `api/enrolments/cancel/${enrolmentId}`,
		method: 'PUT',
		schema: Schemas.ENROLMENT,
		form: 'enrolment',
		onSuccessEvent
	}
});

export const deleteAutoEnrolment = (enrolmentId, onSuccessEvent) => ({
	[CALL_API]: {
		types: [DELETE_AUTO_ENROLMENT_REQUEST, DELETE_AUTO_ENROLMENT_SUCCESS, DELETE_AUTO_ENROLMENT_FAILURE],
		endpoint: `api/enrolments/autoEnrolment/${enrolmentId}`,
		method: 'DELETE',
		schema: Schemas.ENROLMENT,
		form: 'enrolment',
		onSuccessEvent
	}
});

export const exportEnrolments = (options, onSuccessEvent) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [ENROLMENTS_EXPORT_REQUEST, ENROLMENTS_EXPORT_SUCCESS, ENROLMENTS_EXPORT_FAILURE],
			endpoint: `api/enrolments/export`,
			request: {
				...options,
				timeZone: globalize.getCurrentTimeZone(getState().configuration.franchisor)
			},
			onSuccessEvent
		},
		format: 'Excel',
		filename: () => `Enrolments-${moment().format('YYYY-MM-DD')}.xlsx`
	});
}

export const exportBadges = (options, onSuccessEvent) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [CHILD_BADGES_EXPORT_REQUEST, CHILD_BADGES_EXPORT_SUCCESS, CHILD_BADGES_EXPORT_FAILURE],
			endpoint: `api/enrolments/exportBadges`,
			request: {
				...options,
				timeZone: globalize.getCurrentTimeZone(getState().configuration.franchisor)
			},
			onSuccessEvent
		},
		format: 'pdf',
		filename: () => `Badges-${moment().format('YYYY-MM-DD')}.pdf`
	});
}